/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';
import { DocumentDisplay } from '@mairistem/administres-utils';

interface ModalDocumentsRecenseProps {
  identifiant: string | number;
  nomFamille: string;
  prenom: string;
  onClose: () => void;
}

const ModalDocumentsRecense = (props: ModalDocumentsRecenseProps) => {
  const { identifiant, nomFamille: nom, prenom, onClose } = props;

  return (
    <Modal open onClose={onClose} size="large" closeIcon>
      <Modal.Header>
        Documents relatifs à {nom} {prenom}
      </Modal.Header>
      <Modal.Content>
        <DocumentDisplay
          identifiant={identifiant}
          apiRoute="/api/administres/recensement-citoyen"
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          content="Fermer"
          icon="close"
          size="tiny"
          basic
          onClick={onClose}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalDocumentsRecense;
